export const SMS_API_KEY = "pk_F8j--qkTJ4h6ity3aSF3WWdbmFai5LrnjvgTKtkSbWWmoqUS6yf69HEMsyMeEhR5";
export const SMS_FROM_NUMBER = "+919717619858";
export const SMS_BASE_URL = "https://api.httpsms.com/v1/messages/send";
export const RAZORPAY_KEY = "rzp_live_SQbTQoHcYlYbtk";

export const MAP_KEY = "AIzaSyDYEl_7PdLfUJdjh4zntpVLow0KcA54Zdk";

export const GST = 5;
